// extracted by mini-css-extract-plugin
export default {"inputContainer":"children_age_input_inputContainer__C1c25"};